<template>
    <div>{{ display }}</div>
</template>

<script>
export default {
    name: "KeysToValuesDisplay",
    props: {
        keys: String,
        values: Object,
        showKeysAsValue: {
            type: Boolean,
            default: false,
        },
        showKeysAndValue: {
            type: Boolean,
            default: false,
        },
        distinct: {
            type: Boolean,
            default: false
        },
        sorted: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        display() {
            if (!this.keys) {
                return;
            }
            let keysSplit = this.keys.split(',');
            let display = [];
            keysSplit.forEach((key) => {
                let value = this.values[key];

                // handle view options
                if (this.showKeysAndValue) {
                    value = key + ' - ' + this.values[key];
                } else if (this.showKeysAsValue) {
                    value = key;
                }

                if (
                    value
                    && (
                        !this.distinct
                        || !display.includes(value)
                    )
                ) {
                    display.push(value);
                }
            });

            if (this.sorted) {
                display.sort()
            }

            return display.join(', ');
        }
    }
}
</script>

<style scoped>

</style>